import { useInViewport } from '@mantine/hooks'
import { useEffect, useState } from 'react'

/**
 * When in viewport and out of viewport,
 * and return viewport again, keep the render status, avoid double times render
 */
export default function useHasAppearedInViewport() {
  const { ref, inViewport } = useInViewport()
  const [hasAppearedInViewport, setHasAppearedInViewport] = useState(false)
  useEffect(() => {
    if (inViewport) {
      setHasAppearedInViewport(true)
    }
  }, [inViewport])

  return {
    hasAppearedInViewport,
    ref,
  }
}
